import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Question {
  component_text: string;
}

@Component({
  selector: 'wcc-warning-box',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-box.component.html',
  styleUrl: './warning-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningBoxComponent {
  @Input() question: Question = {
    component_text: '',
  };

  @Input() returnConfig: string;

  restartJourney() {
    window.location.href = this.returnConfig;
  }
}